<template>
	<div class="modal-info">
		<div class="content">
			<div class="content">
				<h2>STEAL ESTATE</h2>
				<p>For mobile viewing, STEAL ESTATE is best experienced in portrait mode. To view STEAL ESTATE on a wider screen, you can experience this site on any laptop or desktop with a supported internet browser.</p>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
	.modal-info {
		position: fixed;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
		background-color: rgba(0,0,0,.8);
		z-index: 9999;
		display: none;

		.content {
			position: fixed;
			top: 50%;
			left: 50%;
			z-index: 99991;
			transform: translate(-50%, -50%);
			background-color: #fff;
			width: 400px;
			padding: 20px;
			border-radius: 15px;

			h2 {
				font-size: 25px;
				font-weight: 500;
				text-align: center;
				margin-bottom: 20px;
			}

			p {
				font-size: 14px;
				font-style: italic;
				margin-bottom: 0;
			}
		}

		@media screen and (max-width: 768px) and (orientation: landscape) and (hover: none) {
			display: block;
		}
	}
</style>

